import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "form", "resultRange", "summary"]

  connect() {
    this.closeBeforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
    this.close()
  }

  show(event) {
    if (this.continuing || !this.hasFormTarget) return

    event.preventDefault()
    this.continuing = true
    this.formTarget.requestSubmit()
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.close()
    }
  }

  continue() {
    if (!this.hasDialogTarget || !this.hasFormTarget) return

    this.continuing = true
    this.dialogTarget.close()
    this.formTarget.requestSubmit()
  }
}
